/*
 * Copyright (c) 2024-2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import PropTypes from 'prop-types';

class GridSection extends Component {
    render() {
        let {title, children, className = ""} = this.props
        return (
            <div className={` pt-2 pl-2 pr-1 w-full @container ${className}`}>
                <div className={"text-xs ml-11 text-gray-500"}>{title}</div>
                <ul className=" grid grid-cols-1 @xs:grid-cols-2  gap-2 pt-2  pb-1">
                    {children}

                </ul>
            </div>

        );
    }
}

GridSection.propTypes = {
    title: PropTypes.any,
    className: PropTypes.string
};

GridSection.defaultProps = {};


export default GridSection;